/*
  Shopify's own Shopify.formatMoney (from shopify_common.js) is only injected on
  some pages, not guaranteed sitewide - so client-side features that need to
  format a raw cents value (recently viewed, wishlist) use this instead.
*/
window.MalobyFormatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const format2 = format || '${{amount}}';
  const match = format2.match(placeholderRegex);
  let value = '';

  switch (match ? match[1] : 'amount') {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return match ? format2.replace(placeholderRegex, value) : value;
};
